import { useEffect, useRef } from 'react'

import { useImpersonation } from '@/contexts/impersonation/impersonation-context'
import { track } from '@/lib/segment'

const STORAGE_KEY = 'segment_has_visited'

export function SegmentSession() {
	const { isImpersonating } = useImpersonation()
	const hasFired = useRef(false)

	useEffect(() => {
		if (isImpersonating || hasFired.current) return
		hasFired.current = true

		const hasVisitedBefore = localStorage.getItem(STORAGE_KEY) === 'true'

		track('Platform Session Started', {
			isFirstVisit: !hasVisitedBefore,
			isReturning: hasVisitedBefore,
		})

		if (!hasVisitedBefore) {
			localStorage.setItem(STORAGE_KEY, 'true')
		}
	}, [isImpersonating])

	return null
}
